/**
 * File: booksTidyData.ts
 * Path: packages/config/src/accounting/booksTidyData.ts
 * Description: Where the books tidy-up Liam agreed on 18 October 2026 moved
 * the imported Zoho lines. The tidy-up has run; Compare with Zoho still reads
 * this table to map Zoho's old accounts to the new ones.
 */

/**
 * Where a line of an imported Zoho journal moves: every line on `from`, or
 * only those whose memo ("vendor: description") fits `when`. Only the account
 * changes, never the amount, date or number. Moves go between expense
 * accounts only, so no year's profit changes.
 */
export interface TidyMove {
  from: string;
  to: string;
  when?: RegExp;
  why: string;
}

export const TIDY_MOVES: readonly TidyMove[] = [
  { from: "5000", to: "5200", when: /\bresale\b/i, why: "bought to sell on" },
  { from: "6390", to: "5200", when: /\bresale\b/i, why: "bought to sell on" },
  { from: "6210", to: "5000", when: /^(godaddy|domains\.co\.za)\b/i, why: "domains are cost of sales" },
  { from: "6100", to: "5100", why: "subcontractors on client work" },
  { from: "6110", to: "5100", why: "freelancers on client work" },
  { from: "6230", to: "5000", why: "Google Cloud is cost of sales" },
  { from: "6370", to: "6200", why: "licences join software" },
  { from: "6380", to: "6260", why: "repairs join equipment" },
  { from: "6330", to: "6310", why: "networking joins advertising" },
  { from: "6290", to: "6390", why: "research joins sundry" },
];
